import config from 'devextreme/core/config';

config({
  licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjExYmRhZTIxLWVmZjktNGQ1Ny1iYWYzLWM0NTIwOWZhZjZmYSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.pOaKT3r9L8fWsnoh9C+SgbhKMqCaDb5HqfOExCVhrIF1QL7++Z2+VVy92rF4zQarDkyQCi9zMsebGJZA9Q3yD6gBtpuiP/2SjZM1p8qt6FLgFGkrqkUpXreNe62zXcgiVW7fxg=='
});

Promise.all([])
.catch(err => console.error(err))
.then(() => import('./bootstrap'))
.catch(err => console.error(err));